import { CategoriasForm } from "./CategoriasForm";

export default CategoriasForm;
